var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"px-3 rounded-full text-sm",class:{
      'tag--low': _vm.priority == 1,
      'tag--medium': _vm.priority == 2,
      'tag--high': _vm.priority == 3
    }},[_vm._v(" "+_vm._s(_vm.priority == 1 ? 'L' : _vm.priority == 2 ? 'M' : 'H')+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }